import React from 'react';
interface FormInputProps {
  label: string;
  type?: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  options?: Array<{
    value: string;
    label: string;
  }>;
}
const FormInput = ({
  label,
  type = 'text',
  name,
  placeholder,
  required = false,
  className = '',
  value,
  onChange,
  options
}: FormInputProps) => {
  const inputClass = 'w-full px-4 py-3 bg-surface border border-border rounded text-text-primary focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all duration-200 font-body';
  return <div className={`mb-4 ${className}`} data-id="element-108">
      <label htmlFor={name} className="block mb-2 font-display font-semibold text-primary text-sm tracking-wider" data-id="element-109">
        {label} {required && <span className="text-gold-glow" data-id="element-110">*</span>}
      </label>
      {type === 'textarea' ? <textarea id={name} name={name} placeholder={placeholder} required={required} className={inputClass} rows={4} value={value} onChange={onChange} data-id="element-111" /> : type === 'select' ? <select id={name} name={name} required={required} className={inputClass} value={value} onChange={onChange} data-id="element-112">
          <option value="" data-id="element-113">Select an option</option>
          {options?.map(option => <option key={option.value} value={option.value} data-id="element-114">
              {option.label}
            </option>)}
        </select> : <input type={type} id={name} name={name} placeholder={placeholder} required={required} className={inputClass} value={value} onChange={onChange} data-id="element-115" />}
    </div>;
};
export default FormInput;